import React from 'react';
export function Stats() {
  const stats = [{
    value: '10,000+',
    label: 'Resumes Written'
  }, {
    value: '95%',
    label: 'Client Satisfaction Rate'
  }, {
    value: '5,000+',
    label: 'Executive Clients Served'
  }, {
    value: '500+',
    label: 'Board Candidates Supported'
  }, {
    value: '100+',
    label: 'Industries Covered'
  }, {
    value: 'Global',
    label: 'Client Reach'
  }];
  return <section className="py-20 bg-charcoal-900 relative overflow-hidden" data-id="element-411">
      <div className="absolute inset-0 opacity-5" data-id="element-412">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-413"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-414">
        <div className="text-center mb-16" data-id="element-415">
          <span className="text-gold font-semibold tracking-widest uppercase text-sm mb-4 block" data-id="element-416">
            Why Choose Us
          </span>
          <h2 className="text-3xl md:text-5xl font-serif-display font-bold text-white mb-6" data-id="element-417">
            A Track Record of Executive Excellence
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-12" data-id="element-418">
          {stats.map((stat, index) => <div key={index} className="text-center border-l-2 border-gold/30 pl-4 py-2" data-id="element-419">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2 font-serif-display" data-id="element-420">
                {stat.value}
              </div>
              <div className="text-gray-400 text-sm md:text-base font-medium tracking-wide uppercase" data-id="element-421">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}